export default __webpack_public_path__ + "static/media/MAKE-HOVER-ANIM.3b6c375c.gif";